import {ENUMVoucherTypes} from "@/Interfaces/EnumVouchers";
import {computed, reactive, readonly, UnwrapRef} from "vue";

const allLangs: Array<Record<string, any>> = [


    {
        label: "FR",
        value: "fr-LU",
    },
    {
        label: "EN",
        value: "en-LU",
    },
];

const langMaps: Record<'en-LU' | 'fr-LU', 'en' | 'fr' > = {
    "en-LU": "en",
    "fr-LU": "fr",
};

const state = reactive({
    lang: "en-LU",
    languages: allLangs,
    languagesMap: langMaps,
});

/**
 *
 * @param langValue
 */
const getLangByValue = (langValue: 'en-LU' | 'fr-LU'): 'en' | 'fr' | 'nl' => {
    if (langValue in state.languagesMap) {
        return state.languagesMap[langValue];
    }
    throw new Error("Invalid Language" + JSON.stringify(langValue));
};

export const langStore = readonly({
    setters: {
        /**
         * Set the language to the current storage
         * @param lang
         */
        setCurrentLang: (lang: string) => {
            state.lang = lang;
            return this;
        },
    },
    actions: {
        getLangByValue,
    },
    getters: {
        /**
         * Get the current language by the lang storage
         */
        getCurrentLang: computed(() => state.lang),
        languages: computed(() => state.languages),
    },
});
